import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

const SEO = ({
  title,
  description,
  ogTitle,
  ogDescription,
  pathname,
  lang,
  videoSchema,
  schema,
  ogImageUrl,
}) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { defaultTitle, defaultDescription, siteUrl, image, twitterUsername },
      },
    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${ogImageUrl || image}`,
        url: `${siteUrl}${pathname || '/'}`,
      }
      const og = {
        title: ogTitle || seo.title,
        description: ogDescription || seo.description,
        image: `${siteUrl}${ogImageUrl || image}`,
        url: `${siteUrl}${pathname || '/'}`,
      }
      return (
        <>
          <Helmet title={seo.title}
            htmlAttributes={{
              lang: lang || 'en',
            }}
          >
            <meta charset="utf-8" />
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            {/* Canonical URL */}
            {seo.url && <link rel="canonical" href={seo.url} />}

            {/* FB open graph */}
            {og.url && <meta property="og:url" content={og.url} />}
            <meta property="og:type" content="website" />
            {og.title && <meta property="og:title" content={og.title} />}
            {og.description && <meta property="og:description" content={og.description} />}
            {og.image && <meta property="og:image" content={og.image} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            {twitterUsername && (
              <meta name="twitter:site" content={twitterUsername} />
            )}
            {twitterUsername && (
              <meta name="twitter:creator" content={twitterUsername} />
            )}
            {og.title && <meta name="twitter:title" content={og.title} />}
            {og.description && <meta name="twitter:description" content={og.description} />}
            {og.image && <meta name="twitter:image" content={og.image} />}

            <meta name="theme-color" content="#000000" />

            {(schema || videoSchema) && (
              <script type="application/ld+json">
                {JSON.stringify(schema || videoSchema)}
              </script>
            )}
          </Helmet>
        </>
      )
    }}
  />
)

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  ogTitle: PropTypes.string,
  ogDescription: PropTypes.string,
  pathname: PropTypes.string,
  schema: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  videoSchema: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  ogTitle: null,
  ogDescription: null,
  pathname: null,
  schema: null,
  videoSchema: null,
}

const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle,
        defaultDescription,
        siteUrl: url,
        image,
        twitterUsername
      }
    }
  }
`
